exports.pattern = {
  username: /^[a-zA-Z][a-zA-Z0-9_]{3,15}$/, // 4到16位（字母，数字，下划线，首字母英文）
  password: /(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/, // 8-20位，包括至少1个大写字母，1个小写字母，1个数字
  projectname: /^[a-zA-Z0-9_]{1,16}$/, // 1到16位（字母，数字，下划线，减号）
  // for fuzzy search
  searchUsername: /^[a-zA-Z0-9_]{1,16}$/, // 1到16位（字母，数字，下划线）
}

exports.reqAnalyticTs = function (period, uid, apikey, network, tzofs) {
  this.period = period; // xxh, xxd
  this.uid = uid;
  this.apikey = apikey;
  this.network = network;
  this.tzofs = tzofs; // number
}

exports.reqAnalyticTopn = function (aspect, n, period, uid, apikey, network, tzofs) {
  this.aspect = aspect,
  this.n = n;
  this.period = period; // xxh, xxd
  this.uid = uid;
  this.apikey = apikey;
  this.network = network;
  this.tzofs = tzofs; // number
}

exports.pageDirection = {
  init: 0,
  prev: 1,
  next: 2,
  jump: 3
};

var resCode = {
  // common
  SUCCESS: 0,
  // account
  VERIFY_CODE_MISMATCH: 1,
  EMAIL_ALREADY_EXIST: 2,
  USERNAME_ALREADY_EXIST: 3,
  VERIFY_CODE_SENT: 4,
  SEND_VERIFY_CODE_FAIL: 5,
  USER_PASSWORD_MISMATCH: 6,
  USER_NOT_FOUND: 7,
  INVALID_TOKEN: 8,
  INVALID_RECAPTCHA: 9,
  ACCOUNT_ABNORMAL: 10,
  // project
  PROJECT_ALREADY_EXIST: 100,
  PROJECT_NOT_FOUND: 101,
  // other
  INVALID_PARAM: 200,
  NO_MORE_DATA: 201,
  //
  UNKNOWN_ERROR: 1000
};
exports.resCode = resCode;

exports.resBody = function (code) {
  this.CODE = (typeof code !== 'undefined') ? code: resCode.SUCCESS;
  this.DATA = null;
}



//////////////////
// WEBPACK FOOTER
// ./server/common/data.js
// module id = 25
// module chunks = 1